/* eslint-disable import/prefer-default-export */
import { formatInTimeZone } from 'date-fns-tz';
import format from 'date-fns/format';
import frLocale from 'date-fns/locale/fr';
import esLocale from 'date-fns/locale/es';
import itLocale from 'date-fns/locale/it';
import enUsLocale from 'date-fns/locale/en-US';
import { isBefore } from 'date-fns';
import isAfter from 'date-fns/isAfter';
import parse from 'date-fns/parse';
import addDays from 'date-fns/addDays';
import subDays from 'date-fns/subDays';

export const DATE_FNS_LOCALE_MAP: Record<string, any> = {
  'fr-FR': frLocale,
  'es-ES': esLocale,
  'it-IT': itLocale,
  'en-US': enUsLocale,
};

const MERIDIAN_DATE_FORMAT = 'yyyy-MM-dd';

export const formatDate = (
  dateObj: any,
  dateFormat: string,
  locale?: string
) => {
  return format(
    dateObj,
    dateFormat,
    locale && DATE_FNS_LOCALE_MAP[locale]
      ? { locale: DATE_FNS_LOCALE_MAP[locale] }
      : {}
  );
};

export const formatDateInTimezone = (
  dateObj: any,
  dateFormat: string,
  locale?: string
) => {
  if (!dateObj) {
    return null;
  }
  const formattedDate = formatInTimeZone(
    dateObj,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    dateFormat,
    locale && DATE_FNS_LOCALE_MAP[locale]
      ? { locale: DATE_FNS_LOCALE_MAP[locale] }
      : {}
  );
  return formattedDate;
};

export const getTimeZone = () => {
  return new Date()
    .toLocaleTimeString('en-us', { timeZoneName: 'short' })
    .split(' ')[2];
};

export const isBlockedDateInCalendar = (date: string, startDate: string, maxFutureAllowedDays: number, maxPastAllowedDays: number) => {
  const parsedStartDate = parse(startDate,MERIDIAN_DATE_FORMAT, new Date());
  const parsedEndDate = parse(date, MERIDIAN_DATE_FORMAT, new Date());
  const nextMaximumFutureAllowedDate = addDays(parsedStartDate, maxFutureAllowedDays);
  const nextMaximumPastAllowedDate = subDays(parsedStartDate, maxPastAllowedDays);
  return (
    isAfter(parsedEndDate, nextMaximumFutureAllowedDate) ||
    isBefore(parsedEndDate, nextMaximumPastAllowedDate) 
  );
}